import { memo, useMemo } from "react";

import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import { Contents } from "./components";

type Props = {
	hostContents: SearchedContent;
	guestContents: SearchedContent;
};

export const MainSection = memo(({ hostContents, guestContents }: Props) => {
	const canShowHostContents = useMemo(() => hostContents.length > 0, [hostContents]);
	const canShowGuestContents = useMemo(() => guestContents.length > 0, [guestContents]);

	return (
		<div className="w-full">
			<div className="grid scroll-pt-10 gap-y-5">
				{canShowHostContents && <Contents title="ホスト" contents={hostContents} />}
				{canShowGuestContents && <Contents title="ゲスト" contents={guestContents} />}
			</div>

			{!canShowHostContents && !canShowGuestContents && (
				<div className="flex justify-center">
					<div className="text-xl">キーワードに該当するFAQが見つかりませんでした。</div>
				</div>
			)}
		</div>
	);
});
